import { isScreenAtLeast } from '../common/utils/index.js';

const els = {
    $navToggle: () => $('[data-nav-toggle]'),
    $nav: () => $('[data-nav-main]'),
    $menuItems: () => $('[data-main-menu-item]'),
    $subMenus: () => $('[data-main-sub-menu]'),
};

const isDesktopNav = () => isScreenAtLeast('lg');

const closeSubMenus = () => {
    els.$subMenus().attr('data-active', '0');
};

const closeMainNav = () => {
    els.$navToggle().attr('data-active', '0');
    els.$nav().attr('data-active', '0');
};

const toggleMainNav = () => {
    const $navToggle = els.$navToggle();
    const $nav = els.$nav();
    const nextState = $navToggle.attr('data-active') === '1' ? '0' : '1';

    $navToggle.attr('data-active', nextState);
    $nav.attr('data-active', nextState);
};

const toggleSubMenu = ($subMenu) => {
    const shouldOpen = $subMenu.attr('data-active') !== '1';

    closeSubMenus();
    $subMenu.attr('data-active', shouldOpen ? '1' : '0');
};

const bindSubMenuClicks = () => {
    els.$menuItems().children('a').on('click', function(event) {
        const $link = $(this);
        const $subMenu = $link.next('[data-main-sub-menu]');

        if ($link.attr('href') === '#') {
            event.preventDefault();
        }

        if (!$subMenu.length) {
            return;
        }

        toggleSubMenu($subMenu);
    });
};

const bindSubMenuHovers = () => {
    els.$menuItems()
        .on('mouseenter', function() {
            if (!isDesktopNav()) {
                return;
            }

            const $subMenu = $(this).find('[data-main-sub-menu]');

            if (!$subMenu.length) {
                closeSubMenus();
                return;
            }

            if ($subMenu.attr('data-active') !== '1') {
                closeSubMenus();
            }

            $subMenu.attr('data-active', '1');
        })
        .on('mouseleave', function() {
            if (!isDesktopNav()) {
                return;
            }

            $(this).find('[data-main-sub-menu]').attr('data-active', '0');
        });
};

const bindMainNavToggle = () => {
    els.$navToggle().on('click', (event) => {
        event.preventDefault();
        toggleMainNav();
    });
};

const bindResize = () => {
    $(window).on('resize:horizontally', () => {
        if (!isDesktopNav()) {
            return;
        }

        closeMainNav();
        closeSubMenus();
    });
};

const initialize = () => {
    if (!els.$nav().length) {
        return;
    }

    bindSubMenuClicks();
    bindSubMenuHovers();
    bindMainNavToggle();
    bindResize();
};

export default {
    initialize,
};
